module.exports = __webpack_public_path__ + "img/CAKE.7ae60655.png";